import React, {memo} from "react"
import {doughnutOptions} from "../settings/options"
import {Doughnut} from "react-chartjs-2"
import {useHistory} from "react-router-dom"
import { useLocalization } from "../../../hooks/localization"
type Props = {
    data: object
    value: number
    page: number
}
export const DoughnutChart = memo(function DoughnutChart({data, value, page}: Props) {
    const history = useHistory();
    const {t} = useLocalization();
    return (
        <div className="energy-box" onDoubleClick={() => history.push(`/energy/${page}`)}>
            <span>{t("energy_page.energy_consumption")}</span>
            <div className="energy-page">
                {(
                    <>
                        {/* @ts-ignore */}
                        <Doughnut data={data} options={doughnutOptions} />
                        <span>{value}</span>
                        <span>kW</span>
                    </>
                ) || <div className="mini-spin" />}
            </div>
        </div>
    )
})
